import React, {useState} from 'react';
import {IconButton} from '@mui/material';
import {Delete} from '@mui/icons-material';
import {AxiosResponse} from 'axios';
import {authorizedAPI} from 'app/services/api';
import DeleteDialog from 'app/components/dialog/DeleteDialog';
import isAxiosError from 'app/helpers/isAxiosError';
import {DefaultApiErrorResponse} from 'app/common/errorTypes';

interface DeleteScorerButtonProps {
  matchEventId: number;
  matchSlug: string;
  onDelete: (matchEventId: number) => void;
  onError: (message: string) => void;
}

const deleteGoalEvent = (matchSlug: string, matchEventId: number): Promise<AxiosResponse<void>> => {
  return authorizedAPI.delete(`/matches/${matchSlug}/goals/${matchEventId}`);
};

export default function DeleteScorerButton({matchEventId, matchSlug, onDelete, onError}: DeleteScorerButtonProps) {
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    deleteGoalEvent(matchSlug, matchEventId)
      .then(() => {
        handleClose();
        onDelete(matchEventId);
      })
      .catch(error => {
        handleClose();
        if (isAxiosError<DefaultApiErrorResponse>(error)) {
          const errorData = error.response?.data?.error;
          if (errorData?.translated_message) {
            return onError(errorData.translated_message);
          }
        }
        return onError('Beim Löschen ist ein unbekannter Fehler aufgetreten, versuche es später erneut.');
      });
  };

  return (
    <>
      <IconButton title='Torschütze löschen' onClick={() => setOpen(true)} sx={{justifySelf: 'center'}}>
        <Delete color='action' />
      </IconButton>
      <DeleteDialog
        description='Der Eintrag im Liveticker wird gelöscht, der Spielstand bleibt unverändert.'
        open={open}
        onReject={handleClose}
        onResolve={handleDelete}
        title='Torschütze löschen?'
      />
    </>
  );
}
